import React from 'react'
import icon from './svgs/FireClockColored.svg'
import { BaseIcon } from './_base'

export const FireClockColoredIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
